import { render, staticRenderFns } from "./gSwiper.vue?vue&type=template&id=b304f750&scoped=true&"
import script from "./gSwiper.vue?vue&type=script&lang=js&"
export * from "./gSwiper.vue?vue&type=script&lang=js&"
import style0 from "./gSwiper.vue?vue&type=style&index=0&id=b304f750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b304f750",
  null
  
)

export default component.exports